import { QrCode, UserRole } from 'shared/types/user'

export interface LoginRequest {
  email: string
  password: string
  remember_me: boolean
  otp?: string
  // how long the token is valid for in minutes -- use during development only
  ttl_minutes?: number
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  user_roles: UserRole[]
  token_type: 'bearer' | string
  qr_code: QrCode | null
  expires_in: number
  is_internal_login: boolean
  classic: boolean
}
